type propType = {
	accountNumber: string
};
export const AccountNumber: string = ({ accountNumber }: propType) => {
	return accountNumber.slice(0, -3) + " " + accountNumber.slice(-3);
};



// WEBPACK FOOTER //
// ./src/components/atomic/atoms/AccountNumber/AccountNumber.js